import {
  VOUCHER_FINISHES,
  type VoucherFinish,
} from 'content/gifting/voucherConfig';

// The design of each redeemed card, by its last characters, so the applied note
// can match the card. Display only and per device; Shopify never sees it.
const KEY = 'uh_gift_card_designs';
const MAX_CARDS = 10;

const read = (): Record<string, string> => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '{}');
    return v && typeof v === 'object' ? v : {};
  } catch {
    return {};
  }
};

export function rememberGiftCardDesign(last4: string, finish: VoucherFinish) {
  const id = last4.toUpperCase();
  const rest = Object.entries(read()).filter(([k]) => k !== id);
  const next = Object.fromEntries([...rest, [id, finish]].slice(-MAX_CARDS));
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Storage blocked: the note falls back to the default.
  }
}

export function giftCardDesignFor(last4: string): VoucherFinish | null {
  const f = read()[last4.toUpperCase()] as VoucherFinish | undefined;
  return f && VOUCHER_FINISHES.includes(f) ? f : null;
}
